import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest");
  const _component_a_space_compact = _resolveComponent("a-space-compact");
  return _openBlock(), _createBlock(_component_a_space_compact, {
    block: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form_item_rest, null, {
      default: _withCtx(() => [_createVNode(_component_a_select, {
        "field-names": $setup.fieldNames,
        options: $setup.provinceList,
        value: $setup.selectProvince,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.selectProvince = $event),
        onChange: $setup.handleProvinceChange,
        "allow-clear": "",
        placeholder: "选择省份"
      }, null, 8, ["field-names", "options", "value", "onChange"]), _createVNode(_component_a_select, {
        "field-names": $setup.fieldNames,
        options: $setup.cityList,
        value: $setup.selectCity,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.selectCity = $event),
        onChange: $setup.handleCityChange,
        "allow-clear": "",
        placeholder: "选择(州)市"
      }, null, 8, ["field-names", "options", "value", "onChange"]), _createVNode(_component_a_select, {
        "field-names": $setup.fieldNames,
        options: $setup.countyList,
        value: $setup.selectCounty,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.selectCounty = $event),
        onChange: $setup.handleCountyChange,
        "allow-clear": "",
        placeholder: "选择(区)县"
      }, null, 8, ["field-names", "options", "value", "onChange"])]),
      _: 1
    })]),
    _: 1
  });
}